import { cn } from '@/lib/utils';
import { forwardRef } from 'react';
import type { ButtonHTMLAttributes } from 'react';

export interface GlassButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'default' | 'primary';
}

export const GlassButton = forwardRef<HTMLButtonElement, GlassButtonProps>(
  ({ className, variant = 'default', children, ...props }, ref) => {
    return (
      <button
        ref={ref}
        className={cn(
          'inline-flex items-center justify-center',
          'px-4 py-2 rounded-xl',
          'backdrop-blur-sm',
          'border border-white/30',
          'transition-all duration-200',
          'focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
          'disabled:opacity-50 disabled:cursor-not-allowed',
          variant === 'default' && [
            'bg-white/20 dark:bg-white/10',
            'hover:bg-white/30 dark:hover:bg-white/20',
            'text-foreground',
          ],
          variant === 'primary' && [
            'bg-primary/80 dark:bg-primary/70',
            'hover:bg-primary/90 dark:hover:bg-primary/80',
            'text-primary-foreground',
          ],
          className
        )}
        {...props}
      >
        {children}
      </button>
    );
  }
);

GlassButton.displayName = 'GlassButton';
